import { render, staticRenderFns } from "./recentlyRead.vue?vue&type=template&id=05a204e6&scoped=true&"
import script from "./recentlyRead.vue?vue&type=script&lang=js&"
export * from "./recentlyRead.vue?vue&type=script&lang=js&"
import style0 from "./recentlyRead.vue?vue&type=style&index=0&id=05a204e6&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a204e6",
  null
  
)

export default component.exports